import css from './share-button.css'

export default function() {
    return `<div class="${css.share}" onclick="toggleShareMenu()" data-haslabel>
            <div data-label>Share</div>
        </div>`
}



// WEBPACK FOOTER //
// ./js/embeds/gif/components/footer/share-button/index.js